// should be a string with city - state
export const cityAndStateValidator = (value: unknown) => {
  if (typeof value !== 'string') {
    return false;
  }

  const [city, state] = value.split(' - ');

  if (!city || !state) {
    return false;
  }

  if (city.length <= 0 || city.length <= 0) {
    return false;
  }

  return true;
};
